import React, { useEffect } from 'react';
import { Dashboard as DashboardLayout } from 'layouts';
import { Grid2 } from '@mui/material';
import styles from './styles';
import { makeStyles } from '@mui/styles';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Clear, PriorityHigh, Warning } from '@mui/icons-material';
import { getSystemAlerts } from 'js/actions/systemAlertAction';
import Card from './components/Card';
import AlertTable from './components/AlertTable';
const useStyles = makeStyles(styles);

export default function NotificationDashboard() {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { systemAlert } = useSelector((state) => state.systemAlert);

  useEffect(() => {
    dispatch(getSystemAlerts());
  }, []);

  return (
    <DashboardLayout title="Control de Alertas">
      <div className={classes.root}>
        <Grid2 container={true} spacing={4}>
          <Grid2 size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
            <Card
              title={intl.formatMessage({
                id: 'app.alerts.header.lowLevelIssues',
              })}
              icon={
                <PriorityHigh
                  sx={{
                    fontSize: '2rem',
                    color: 'white',
                    height: '2rem',
                    width: '2rem',
                  }}
                />
              }
              alert={systemAlert}
              bgColor="#0086c0"
            />
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
            <Card
              title={intl.formatMessage({
                id: 'app.alerts.header.mediumLevelIssues',
              })}
              icon={
                <Warning
                  sx={{
                    fontSize: '2rem',
                    color: 'white',
                    height: '2rem',
                    width: '2rem',
                  }}
                />
              }
              alert={false}
              bgColor="#fdab3d"
            />
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
            <Card
              title={intl.formatMessage({
                id: 'app.alerts.header.highLevelIssues',
              })}
              icon={
                <Clear
                  sx={{
                    fontSize: '2rem',
                    color: 'white',
                    height: '2rem',
                    width: '2rem',
                  }}
                />
              }
              alert={false}
              bgColor="#e2445c"
            />
          </Grid2>
          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <AlertTable alerts={systemAlert} />
          </Grid2>
        </Grid2>
      </div>
    </DashboardLayout>
  );
}
